import React from 'react';
import {Table, Accordion, Badge} from 'react-bootstrap';
import {useTranslation} from "react-i18next";
import {getRuleName, getScenarioName} from "../../../utils/labelUtils";

const ReceiptTable = ({items}: any) => {
    const { t } = useTranslation();
    return(
        <Table bordered hover size="sm">
            <thead className="table-light">
            <tr>
                <th>{t('Receipt.item')}</th>
                <th>{t('Receipt.qty')}</th>
                <th>{t('Receipt.unit_price')}</th>
                <th>{t('Receipt.total')}</th>
                <th>{t('Receipt.alert')}</th>
            </tr>
            </thead>
            <tbody>
            {items.map((item: any, idx: number) => (
                <React.Fragment key={idx}>
                    <tr className={item.alerts?.length ? 'table-warning' : item.isVoided ? 'table-active' : ''}>
                        <td>
                            {item.name}
                            {item.isVoided && <Badge bg="secondary" className="ms-2">{t('Receipt.voided')}</Badge>}
                        </td>
                        <td>{item.qty}</td>
                        <td>₺{item.unitPrice.toFixed(2)}</td>
                        <td>₺{item.total.toFixed(2)}</td>
                        <td>
                            {item.alerts?.length > 0 && (
                                <Badge bg="danger">{item.alerts.length}</Badge>
                            )}
                        </td>
                    </tr>
                    {item.alerts?.length > 0 && (
                        <tr className="table-light">
                            <td colSpan={5}>
                                <Accordion flush>
                                    <Accordion.Item eventKey={`alerts-${idx}`}>
                                        <Accordion.Header>
                                            {t('Receipt.triggered_alerts')} ({item.alerts.length})
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <ul className="mb-0" style={{fontSize: '0.85rem'}}>
                                                {item.alerts.map((a: any, i: number) => (
                                                    <li key={i}>
                                                        <strong>{t('Receipt.scenario')}:</strong> {getScenarioName(a.scenarioId)}<br/>
                                                        <strong>{t('Receipt.rule')}:</strong> {getRuleName(a.ruleName)}
                                                    </li>
                                                ))}
                                            </ul>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </td>
                        </tr>
                    )}
                </React.Fragment>
            ))}
            </tbody>
        </Table>
    )

}
export default ReceiptTable;